import { Box } from '@mui/material';
import { PrivateRoute } from 'modules';
import { useLocation } from 'react-router-dom';



export const RootLayout = () => {
  const location = useLocation();

  return (
    <Box
      padding='1.5rem'
    >
      <PrivateRoute.FC extraAuthNavState={location.state} />
    </Box>
  );
};
